export const productSellerEndpoints = {
    keywords: {
        dictionary: {
            api: '/api/agora/keywords/dictionary',
            method: 'GET',
            parameter: false
        }
    },
    preProducts: {
        initiateFromPublishedProduct: {
            api: '/api/agora/product-seller/pre-product/edit/initiate',
            method: 'POST',
            parameter: false
        },
        add: {
            api: '/api/agora/product-seller/pre-product/add',
            method: 'POST',
            parameter: false
        },
        addNonHosted: {
            api: '/api/agora/product-seller/pre-product/add',
            method: 'POST',
            parameter: false
        },
        publish: {
            api: '/api/agora/product-seller/pre-product/publish',
            method: 'POST',
            parameter: false
        },
        publishNonHosted: {
            api: '/api/agora/product-seller/pre-product/publish',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/agora/product-seller/pre-product/edit',
            method: 'POST',
            parameter: false
        },
        editNonHosted: {
            api: '/api/agora/product-seller/pre-product/edit',
            method: 'POST',
            parameter: false
        },
        correct: {
            api: '/api/agora/product-seller/pre-product/correct',
            method: 'POST',
            parameter: false
        },
        approve: {
            api: '/api/agora/product-seller/pre-product/approve',
            method: 'POST',
            parameter: false
        },
        approveMulticontent: {
            api: '/api/agora/product-seller/pre-product/approve-multicontent',
            method: 'POST',
            parameter: false
        },
        editApproveMulticontent: {
            api: '/api/agora/product-seller/pre-product/edit-approve-multicontent',
            method: 'POST',
            parameter: false
        },
        reject: {
            api: '/api/agora/product-seller/pre-product/reject',
            method: 'POST',
            parameter: false
        },
        requestChanges: {
            api: '/api/agora/product-seller/pre-product/request-changes',
            method: 'POST',
            parameter: false
        },
        submitChanges: {
            api: '/api/agora/product-seller/pre-product/submit-changes',
            method: 'POST',
            parameter: false
        },
        submitChangesNonHosted: {
            api: '/api/agora/product-seller/pre-product/submit-changes',
            method: 'POST',
            parameter: false
        },
        details: {
            api: '/api/product-seller/pre-product/details',
            method: 'GET',
            parameter: true
        },
        list: {
            api: '/api/product-seller/pre-product/draft',
            method: 'GET',
            parameter: false
        },
        listByStatus: {
            api: '/api/product-seller/pre-product/listByStatus',
            method: 'GET',
            parameter: true
        },
        listDraft: {
            api: '/api/product-seller/pre-product/draft',
            method: 'GET',
            parameter: false
        },
        listFailed: {
            api: '/api/product-seller/pre-product/failed',
            method: 'GET',
            parameter: false
        },
        listApproval: {
            api: '/api/product-seller/pre-product/approval',
            method: 'GET',
            parameter: false
        },
        createVariations: {
            api: '/api/product-seller/pre-product/variations/create',
            method: 'POST',
            parameter: false
        },
        createVariationsNonHosted: {
            api: '/api/product-seller/pre-product/variations/create',
            method: 'POST',
            parameter: false
        },
        editEnrichment: {
            api: '/api/agora/product-seller/pre-product/enrichment',
            method: 'POST',
            parameter: false
        },
        editVariationContent: {
            api: '/api/agora/product-seller/pre-product/variation-content',
            method: 'POST',
            parameter: false
        },
        computePricing: {
            api: '/api/product-seller/pre-product/pricing/compute',
            method: 'POST',
            parameter: false
        },
        computeSellerProceeds: {
            api: '/api/agora/pre-product/compute/sellerProceeds',
            method: 'POST',
            parameter: false
        },

        storePricing: {
            api: '/api/agora/product-seller/pre-product/store/pricing',
            method: 'POST',
            parameter: false
        },
        storePricingNonHosted: {
            api: '/api/agora/product-seller/pre-product/store/pricing',
            method: 'POST',
            parameter: false
        },
        discard: {
            api: '/api/product-seller/pre-product/discard',
            method: 'POST',
            parameter: false
        },
        topicsList: {
            api: '/api/agora/topics/list',
            method: 'GET',
            parameter: false
        },
        uploadMaterials: {
            api: '/api/api/agora/product-seller/pre-product/variation-content-new',
            method: 'POST',
            parameter: false
        },
        uploadNonHostedMaterials: {
            api: '/api/api/agora/product-seller/pre-product/variation-content-new',
            method: 'POST',
            parameter: false
        },
        changeLog: {
            api: '/api/agora/changelog',
            method: 'POST',
            parameter: false
        },
        checkDomain: {
            api: '/api/product-seller/domaincheck',
            method: 'GET',
            parameter: true
        }, 
        productCreationDomainCheck:{
            api: '/api/product-seller/seller-okta-bypass',
            method: 'GET',
            parameter: true  
        }
    },
    products: {
        list: {
            api: '/api/agora/product',
            method: 'GET',
            parameter: false
        },
        listFiltered: {
            api: '/api/agora/product-list-filtered',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/agora/product/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/agora/product/add',
            method: 'POST',
            parameter: false
        },
        activate: {
            api: '/api/agora/product/activate',
            method: 'POST',
            parameter: false
        },
        deactivate: {
            api: '/api/agora/product/deactivate',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/agora/product/edit',
            method: 'POST',
            parameter: false
        },
        editEvalVoucherEnablement: {
            enable: {
                api: '/api/agora/productvariant/bulk/evaluation-copy-available-true',
                method: 'POST',
                parameter: false
            },
            disable: {
                api: '/api/agora/productvariant/bulk/evaluation-copy-available-false',
                method: 'POST',
                parameter: false
            },

        },
        computePricing: {
            api: '/api/product-seller/product/pricing/compute',
            method: 'POST',
            parameter: false
        },
        computeSellerProceeds: {
            api: '/api/agora/product/compute/sellerProceeds',
            method: 'POST',
            parameter: false
        },
        storePricing: {
            api: '/api/product-seller/product/pricing/store',
            method: 'POST',
            parameter: false
        },
        getLibraryContent: {
            api: '/api/library/product/content',
            method: 'POST',
            parameter: false
        },
        getSkuListByDeliverableKey: {
            api: '/api/agora/product/sku-list-by-deliverable',
            method: 'GET',
            parameter: true
        },
        bulkAssignShippingPolicy: {
            api: '/api/product-seller/product/bulk/assign/shipping/policy',
            method: 'POST',
            parameter: true
        }
    },
    productGroups: {
        add: {
            api: '/api/agora/productgroup/add',
            method: 'POST',
            parameter: false
        },
    },
    productVariants: {
        images: {
            edit: {
                api: '/api/agora/productvariant/update-images',
                method: 'POST',
                parameter: false
            }
        },
        examFulfillment: {
            edit: {
                api: '/api/agora/productvariant/examfulfillment/edit',
                method: 'POST',
                parameter: false
            },
            assignCustomPolicy: {
                api: '/api/agora/productvariant/assigncustompolicy',
                method: 'POST',
                parameter: true
            },
        },
        bulkAvailable: {
            api: '/api/agora/bulk/available',
            method: 'POST',
            parameter: false
        },
        bulkUnavailable: {
            api: '/api/agora/bulk/unavailable',
            method: 'POST',
            parameter: false
        },
        list: {
            api: '/api/agora/productvariant',
            method: 'GET',
            parameter: false
        },
        listByProductSKU: {
            api: '/api/agora/productvariant/list/product-sku',
            method: 'GET',
            parameter: true
        },
        readBySKU: {
            api: '/api/agora/productvariant/sku',
            method: 'GET',
            parameter: true
        },
        details: {
            api: '/api/agora/productvariant/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/agora/productvariant/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/agora/productvariant/edit',
            method: 'POST',
            parameter: false
        },
        delete: {
            api: '/api/agora/productvariant/delete',
            method: 'POST',
            parameter: false
        },
        manufacturer: {
            api: '/api/agora/productvariant/manufacturer',
            method: 'GET',
            parameter: true
        },
        unavailable: {
            api: '/api/agora/productvariant/list/unavailable',
            method: 'GET',
            parameter: false
        },
        bulkEdit: {
            api: '/api/agora/productvariant/bulk-edit',
            method: 'POST',
            parameter: false
        },
        getProductContentDeliverablesBySku: '/api/library/productcontent/deliverables/sku',
        examFulfillmentType: {
            api: '/api/agora/productvariant/fulfillment-types',
            method: 'GET',
            parameter: false
        },
        editExamFulfillmentType: {
            api: '/api/agora/productvariant/fulfillment-details/update',
            method: 'POST',
            parameter: false
        },
        customFulfillmentPolicies: {
            add: {
                api: '/api/agora/custom-fulfillment-policy/add',
                method: 'POST',
                parameter: false
            },
            list: {
                api: '/api/agora/custom-fulfillment-policy/',
                method: 'GET',
                parameter: false
            }
        },
        expressCreate: {
            api: '/api/agora/productvariant/express-create',
            method: 'POST',
            parameter: false
        },
        expressContentCreate: {
            api: '/api/agora/productvariant/express-content-create',
            method: 'POST',
            parameter: false
        },
        isLastOnline: {
            api: '/api/agora/productvariant/offline/check',
            method: 'POST',
            parameter: false
        },
        generateThumbnail: {
            api: '/api/agora/productvariant/thumbnail/generate',
            method: 'POST',
            parameter: true
        }
    },
    dictionary: {
        // agora pre-product apis
        deliverableType: {
            api: '/api/agora/configuration/dictionary/pre-deliverable',
            method: 'GET'
        },
        productType: {
            api: '/api/agora/product-seller/dictionary/product-type',
            method: 'GET',
            parameter: false
        },
        productTypeFilter: {
            api: '/api/agora/product-seller/dictionary/product-type-filter',
            method: 'GET',
            parameter: false
        },
        levels: {
            api: '/api/agora/product-seller/dictionary/levels',
            method: 'GET',
            parameter: false
        },
        courseDeliveryFormats: {
            api: '/api/agora/configuration/list/course-delivery-formats',
            method: 'GET',
            parameter: false
        },
        deliveryFormatByProductType: {
            api: '/api/agora/product-seller/dictionary/deliveryFormat',
            method: 'GET',
            parameter: true
        },
        popularLanguages: {
            api: '/api/agora/product-seller/dictionary/popularLanguages',
            method: 'GET',
            parameter: false
        },
        otherLanguages: {
            api: '/api/agora/product-seller/dictionary/otherLanguages',
            method: 'GET',
            parameter: false
        },
        linkTypes: {
            api: '/api/agora/configuration/list/linktype',
            method: 'GET',
            parameter: false
        },
        allLanguages: {
            api: '/api/agora/configuration/dictionary/language-type',
            method: 'GET',
            parameter: false
        },
        certificateTypeList: {
            api: '/api/agora/product-seller/certificate-type',
            method: 'GET',
            parameter: false
        },
        productGroupByCategoryId: {
            api: '/api/agora/product-seller/dictionary/product-group-by-category',
            method: 'GET',
            parameter: true
        },
        regionList: {
            api: '/api/agora/product-seller/dictionary/regions',
            method: 'GET',
            parameter: false
        },
        // agora product apis
        productAccessDuration: {
            api: '/api/agora/configuration/dictionary/p-access-duration',
            method: 'GET',
            parameter: false
        },
        productCourseDuration: {
            api: '/api/agora/configuration/dictionary/p-duration-type',
            method: 'GET',
            parameter: false
        },
        certificateType: {
            api: '/api/agora/configuration/dictionary/p-cert-type',
            method: 'GET',
            parameter: false
        },
        examFulfillmentType: {
            api: '/api/product/exam/fulfilment',
            method: 'GET',
            parameter: false
        },
        category: {
            api: '/api/agora/category/dictionary',
            method: 'GET',
            parameter: false
        },
        seller: {
            api: '/api/agora/account/seller/public/dictionary ',
            method: 'GET',
            parameter: false
        },
        availableSubtopics: {
            api: '/api/agora/topics/subtopics-available-list',
            method: 'GET',
            parameter: true
        },
        brands: {
            api: '/api/agora/configuration/dictionary/brand',
            method: 'GET',
            parameter: false
        },
        productDomain: {
            api: '/api/agora/configuration/dictionary/p-domain',
            method: 'GET',
            parameter: false
        },
        prductType: {
            api: '/api/agora/configuration/dictionary/p-type',
            method: 'GET',
            parameter: false
        },
        getCurrencyByDomain: {
            api: '/api/agora/account/currency',
            method: 'GET',
            parameter: true
        },
        discountStrategy: {
            api: '/api/agora/product-seller/dictionary/list/discount-strategy',
            method: 'GET',
            parameter: false
        },
        customerSegments: {
            api: '/api/agora/list/account-accreditation-type',
            method: 'GET',
            parameter: false
        },
        productSegments: {
            api: '/api/agora/product-segment/seller/dictionary',
            method: 'GET',
            parameter: false
        },
        deliverySpecByType: {
            api: '/api/agora/public/deliverable/spec/read/bytype',
            method: 'POST',
            parameter: true
        },
        categoryListByTopicId: {
            api: '/api/agora/category/list/bytopic',
            method: 'GET',
            parameter: true
        },
        topicList: {
            api: '/api/agora/topics/topic/dict',
            method: 'GET',
            parameter: true
        }
    },
    fulfillmentPolicy: {
        customFulfillmentPolicy: {
            add: {
                api: '/api/agora/custom-fulfillment-policy/add',
                method: 'POST',
                parameter: false
            },
            list: {
                api: '/api/agora/product-seller/custom-fulfillment-policy/filtered-list',
                method: 'GET',
                parameter: false
            }
        }
    },
    configurations: {
        deliverableType: {
            api: '/api/agora/configuration/list/by/pre-deliverable',
            method: 'GET'
        },
        materialType: {
            api: '/api/agora/configuration/list/by/p-material-type',
            method: 'GET',
            parameter: true
        },
        nonHostedMaterialType: {
            api: '/api/agora/configuration/list/by/p-material-non-hosted-type',
            method: 'GET',
            parameter: true
        },
        configurationListBy: {
            api: '/api/agora/configuration/list/by',
            method: 'GET',
            parameter: true
        },
        configurationListByNew: {
            api: '/api/agora/configuration/list/whitelist/by',
            method: 'GET',
            parameter: true
        },

    },
    shippingPolicy: {
        add: {
            api: '/api/agora/product-seller/shipping-policy/add',
            method: 'POST',
            parameter: false
        },
        publish: {
            api: '/api/agora/product-seller/shipping-policy/publish',
            method: 'POST',
            parameter: true
        },
        edit: {
            api: '/api/agora/product-seller/shipping-policy/edit',
            method: 'POST',
            parameter: true
        },
        editRates: {
            api: '/api/agora/product-seller/shipping-policy/edit-rates',
            method: 'POST',
            parameter: true
        },
        editRegions: {
            api: '/api/agora/product-seller/shipping-policy/edit-regions',
            method: 'POST',
            parameter: true
        },
        details: {
            api: '/api/agora/product-seller/shipping-policy/details',
            method: 'GET',
            parameter: true
        },
        list: {
            api: '/api/agora/product-seller/shipping-policy/list',
            method: 'GET',
            parameter: false
        },
        countryDictionary: {
            api: '/api/country/dictionary',
            method: 'GET',
            parameter: false
        },
        publishedList: {
            api: '/api/agora/product-seller/shipping-policy/list-simple',
            method: 'GET',
            parameter: false
        }
    },
    restrictedProductSegments: {
        countriesDict: {
            api: '/api/agora/country/dictionary',
            method: 'GET',
            parameter: false
        },
        templatesList: {
            api: '/api/phoenix/v2/template/list',
            method: 'GET',
            parameter: false
        }
    },
    bulkUploads: {
        list: {
            api: '/api/umbrella/csv',
            method: 'GET',
            parameter: false
        },
        add: {
            api: '/api/umbrella/csv/create',
            method: 'POST',
            parameter: false
        },
        create: {
            api: '/api/umbrella/bulkimport/confirm',
            method: 'POST',
            parameter: false
        },
        validationReport: {
            api: '/api/umbrella/csv/validationreport',
            method: 'GET',
            parameter: true
        },
        listProducts: {
            api: '/api/umbrella/csv/products',
            method: 'GET',
            parameter: false
        },
        productsReport: {
            api: '/api/umbrella/csv/products/summary',
            method: 'GET',
            parameter: true
        },
        retryProductCreation: {
            api: '/api/umbrella/bulkimport/products/trigger',
            method: 'POST',
            parameter: true
        },
        configList: {
            api: '/api/umbrella/config/list',
            method: 'GET',
            parameter: false
        },
        configDetails: {
            api: '/api/umbrella/config/detail',
            method: 'GET',
            parameter: true
        },
        configType: {
            api: '/api/umbrella/config/configtype',
            method: 'GET',
            parameter: false
        },
        configEdit: {
            api: '/api/umbrella/config/edit',
            method: 'POST',
            parameter: true
        },
        configAdd: {
            api: '/api/umbrella/config',
            method: 'POST',
            parameter: false
        },
        listAccountCsv: {
            api: '/api/umbrella/account',
            method: 'GET',
            parameter: false
        },
        addAccountCsv: {
            api: '/api/umbrella/account/bulk/create',
            method: 'POST',
            parameter: false
        },
        accountValidationReport: {
            api: '/api/umbrella/account/validationreport',
            method: 'GET',
            parameter: true
        },
        createAccount: {
            api: '/api/umbrella/account/bulk/register',
            method: 'POST',
            parameter: true
        },
        accountCreationSummary: {
            api: '/api/umbrella/account/summary',
            method: 'GET',
            parameter: true
        },
        listAccounts: {
            api: '/api/umbrella/account/by-status',
            method: 'GET',
            parameter: true
        },
        triggerAccount: {
            api: '/api/umbrella/account/trigger',
            method: 'POST',
            parameter: false
        },
        addOktaSamlApp: {
            api: '/api/agora/okta/saml/app/create',
            method: 'POST',
            parameter: false
        },
        listOktaSamlByDomain: {
            api: '/api/agora/okta/saml/app/list/label',
            method: 'GET',
            parameter: true
        },
        detailsOktaSaml: {
            api: '/api/agora/okta/saml/app/details',
            method: 'GET',
            parameter: true
        },
        editOktaSaml: {
            api: '/api/agora/okta/saml/app/update',
            method: 'POST',
            parameter: false
        },
        listOktaSaml: {
            api: '/api/agora/okta/saml/app/list',
            method: 'GET',
            parameter: false
        },
        deleteOktaSaml: {
            api: '/api/agora/okta/saml/app/deactivate',
            method: 'POST',
            parameter: false
        },
        attributesOktaSaml: {
            api: '/api/agora/okta/saml/app/optional-attributes',
            method: 'GET',
            parameter: false
        },
        keyValueOktaSaml: {
            api: '/api/agora/okta/saml/app/list/label',
            method: 'GET',
            parameter: false
        }

    },
    sellerSubCategories: {
        list: {
            api: '/api/agora/product/subcategory',
            method: 'GET',
            parameter: true
        },
        edit: {
            api: '/api/agora/productgroup/edit/seller',
            method: 'POST',
            parameter: true
        }
    },
    getProductCustomAttributes: {
        list: {
            api: '/api/agora/custom-attributes/list',
            method: 'GET',
            parameter: false
        },
        add: {
            api: '/api/agora/custom-attributes/add',
            method: 'POST',
            parameter: true
        },
        edit: {
            api: '/api/agora/custom-attributes/edit',
            method: 'POST',
            parameter: true
        }
    },
    getTechnologyForCourses:{
        list: {
            api: '/api/agora/domain-configuration/custom-attributes/list',
            method: 'GET',
            parameter: false
        },
    }
};



// WEBPACK FOOTER //
// ./src/endpoints/product-seller.endpoints.ts